var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.0001C6.71664 14.0001 6.43329 13.8924 6.21642 13.6756L0.324514 7.78367C0.117142 7.5763 0 7.29453 0 7.00009C0 6.70566 0.117142 6.42388 0.324514 6.21651L6.21642 0.324606C6.64857 -0.107551 7.35142 -0.107551 7.78358 0.324606C8.21574 0.756764 8.21574 1.45961 7.78358 1.89177L2.67526 7.00009L7.78358 12.1084C8.21574 12.5406 8.21574 13.2434 7.78358 13.6756C7.56671 13.8924 7.28336 14.0001 7 14.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1839 5.89185H1.10815V8.10804H18.1839V5.89185Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1839,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.2e351044000471c6f44d0ece4b9a69d7.svg";
export { ForwardRef as ReactComponent };